import { render, staticRenderFns } from "./all-submit-review.vue?vue&type=template&id=32016bae&scoped=true&"
import script from "./all-submit-review.vue?vue&type=script&lang=js&"
export * from "./all-submit-review.vue?vue&type=script&lang=js&"
import style0 from "./all-submit-review.vue?vue&type=style&index=0&id=32016bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32016bae",
  null
  
)

export default component.exports